import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import { Link, Navigate } from 'react-router-dom';
import Breadcrumb from '../../components/Breadcrumb';
import SingleBlogFour from '../../components/Blog/SingleBlogFour';
import Sidebar from '../../components/Blog/Sidebar';
import DataState from '../../components/DataState';
import { useCollections } from '../../lib/api/collections';

import { newsImages } from '../../data/images';

const BlogSidebarMain = () => {
  const content = useCollections('news');
  if (content.loading || content.error) return <DataState state={content} />;
  const [first, second, third] = content.news;
  if (!first || !second || !third) return <Navigate to="/news" replace />;
  const firstPics = newsImages(first);
  const secondPics = newsImages(second);
  const thirdPics = newsImages(third);
  const sliderOption = {
    speed: 1000,
    loop: true,
    slidesPerView: '1',
    autoplay: {
      delay: 5000,
    },
    navigation: {
      prevEl: '.postbox-arrow-prev',
      nextEl: '.postbox-arrow-next',
    },
  };

  return (
    <main>
      <Breadcrumb title="News Archive" subTitle="News" />

      <div className="postbox__area pt-120 pb-120">
        <div className="container">
          <div className="row">
            <div className="col-xl-8 col-lg-8 mb-40">
              <div className="postbox__details-wrapper">
                <SingleBlogFour
                  itemClass="postbox__thumb-box mb-80"
                  blogImage={firstPics.main}
                  to={`/news/${first.id}`}
                  publishedDate={first.date}
                  authorName={first.author}
                  title={first.titleMid}
                  btnText="Read More"
                />

                <div className="postbox__thumb-box mb-80">
                  <div className="it-postbox__wrapper p-relative mb-30">
                    <div className="swiper-container postbox__thumb-slider-active">
                      <Swiper
                        modules={[Autoplay, Navigation]}
                        {...sliderOption}
                        className="swiper-wrapper"
                      >
                        <SwiperSlide className="swiper-slide">
                          <div className="postbox__main-thumb">
                            <img src={secondPics.main} alt="" />
                          </div>
                        </SwiperSlide>
                        <SwiperSlide className="swiper-slide">
                          <div className="postbox__main-thumb">
                            <img src={secondPics.a} alt="" />
                          </div>
                        </SwiperSlide>
                        <SwiperSlide className="swiper-slide">
                          <div className="postbox__main-thumb">
                            <img src={secondPics.b} alt="" />
                          </div>
                        </SwiperSlide>
                      </Swiper>
                    </div>
                    <div className="postbox__slider-arrow-wrap">
                      <button className="postbox-arrow-prev">
                        <i className="fa-solid fa-arrow-left"></i>
                      </button>
                      <button className="postbox-arrow-next">
                        <i className="fa-solid fa-arrow-right"></i>
                      </button>
                    </div>
                  </div>
                  <div className="postbox__content-box">
                    <div className="postbox__meta">
                      <span>
                        <i className="fa-solid fa-calendar-days"></i>
                        {second.date}
                      </span>
                      <span>
                        <i className="fal fa-user"></i>{second.author}
                      </span>
                    </div>
                    <h4 className="postbox__details-title">
                      <Link to={`/news/${second.id}`}>{second.titleMid}</Link>
                    </h4>
                    <Link className="ed-btn-theme" to={`/news/${second.id}`}>
                      Read More
                      <i>
                        <svg
                          width="17"
                          height="14"
                          viewBox="0 0 17 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11 1.24023L16 7.24023L11 13.2402"
                            stroke="currentcolor"
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M1 7.24023H16"
                            stroke="currentcolor"
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </i>
                    </Link>
                  </div>
                </div>

                <SingleBlogFour
                  itemClass="postbox__thumb-box"
                  blogImage={thirdPics.main}
                  to={`/news/${third.id}`}
                  publishedDate={third.date}
                  authorName={third.author}
                  title={third.titleMid}
                  btnText="Read More"
                />
              </div>
            </div>
            <div className="col-xxl-4 col-xl-4 col-lg-4">
              <Sidebar />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default BlogSidebarMain;
